import { Content, View } from '@adobe/react-spectrum';
import React from 'react';
import { FormField as FormFieldType } from '../store/slice';
import { FormSection } from './FormSection';

interface FormContentProps {
  formFields: FormFieldType[];
  formValues: Record<string, any>;
  onChange: (name: string, value: any) => void;
  onBlur?: (name: string) => void;
  momentTypeId: string;
  validationErrors?: Record<string, string>;
  hasSubmitted?: boolean;
}

export const FormContent: React.FC<FormContentProps> = ({
  formFields,
  formValues,
  onChange,
  onBlur,
  momentTypeId,
  validationErrors = {},
  hasSubmitted = false
}) => {
  // Skip rendering until formFields are available
  if (!formFields.length) {
    return null;
  }

  // Group form fields by section
  const sectionMap = new Map<
    string,
    {
      fields: FormFieldType[];
      config: {
        heading: string;
        subheading?: string;
        required?: boolean;
        columns: number;
        toolTipMessage?: string;
      };
    }
  >();

  // Group fields by section and get section config from first field
  formFields.forEach(field => {
    const sectionName = field.section || '';

    if (!sectionMap.has(sectionName)) {
      sectionMap.set(sectionName, {
        fields: [],
        config: {
          heading: sectionName,
          subheading: field.sectionConfig?.subheading,
          required: (field.sectionConfig as any)?.required,
          columns: field.sectionConfig?.columns || 1,
          toolTipMessage: field.sectionConfig?.toolTipMessage
        }
      });
    }

    sectionMap.get(sectionName)!.fields.push(field);
  });

  // Convert to array for rendering
  const sections = Array.from(sectionMap.entries()).map(
    ([sectionName, data]) => ({
      sectionName,
      ...data
    })
  );

  return (
    <>
      {sections.map(({ sectionName, fields, config }) => (
        <FormSection
          key={`${momentTypeId}-${sectionName}`}
          sectionName={sectionName}
          sectionConfig={config}
          fields={fields}
          formValues={formValues}
          onChange={onChange}
          onBlur={onBlur}
          momentTypeId={momentTypeId}
          validationErrors={validationErrors}
          hasSubmitted={hasSubmitted}
        />
      ))}
    </>
  );
};
